import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'

import { Panel, Message } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ActivityBudgetForm from './ActivityBudgetForm'
import {
  getActivity,
  saveActivity,
  updateActivity,
  deleteActivity,
  getProjectBudget,
} from '../../../redux/actions/budget'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'

export default function ActivityWidgets({ shaded = true, projectVersionId, ...props }) {
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues, setError } =
    useForm()
  const {
    showCommandButton,
    isEdit,
    onChangeIsEdit,
    onExpanded,
    valPanel,
    saveSucceed,
    categoryType,
    activityBudgetValue,
  } = props
  const { bordered, getSummary } = props
  // const { showCommandButton, isEditAll } = props
  const [section, setSection] = useState()
  // const [isEdit, setIsEdit] = useState(false)
  const [isEditDetail, setIsEditDetail] = useState(false)
  const [editDetailIndex, setEditDetailIndex] = useState(-1)
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [expanded, setExpanded] = useState(true)
  const [panelExpanded, setPanelExpanded] = useState(!isEdit)
  const [activityBudgetValues, setActivityBudgetValues] = useState([])
  const [showMessage, setShowMessage] = useState(false)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = projectVersionId || sessionStorage.getItem('projectId')

  useEffect(() => {
    if (props.schema) {
      console.log('udate >>>>>>> ', props.schema)
      setFormSchema(props.schema)
    }
  }, [props.schema])

  useEffect(() => {
    console.log('activityBudgetValue ', activityBudgetValue)
    if (activityBudgetValue) {
      setActivityBudgetValues(activityBudgetValue)
    }
  }, [activityBudgetValue])

  // console.log('props.schema ', props.schema)

  const handleUpdateSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()
    try {
      let response

      if (request.id) {
        console.log('call update.')
        response = await updateActivity(projectId, request)
      } else {
        console.log('call save.')
        response = await saveActivity(projectId, request)
      }

      if (response) {
        setFormSchema(response)
        setIsError(false)
        saveSucceed(true)

        if (!projectVersionId) {
          await dispatch(getSchemaSidebar(projectId))
        }
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (schama) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    try {
      const chk = await chkActivityBudgetValue(schama.id)
      if (chk) {
        const status = await deleteActivity(projectId, schama.id)
        if (status === 200) {
          saveSucceed(true)
          console.log('call get.')
          const _schema = await getActivity(projectId)
          console.log(('result', _schema))

          setFormSchema(_schema)
        } else {
          setIsDeleteError(true)
        }
      } else {
        setShowMessage(true)
        setTimeout(() => setShowMessage(false), 10000)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const chkActivityBudgetValue = (delId) => {
    let count = 0
    if (activityBudgetValues?.length > 0 && delId) {
      activityBudgetValues.map((item) => {
        if (item.activityId === delId) {
          count++
        }
      })
      return count > 0 ? false : true
    } else {
      return true
    }
  }

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    let request = {
      id: data.selectedId,
      projectVersionId: projectId,
      categoryType: categoryType,
      actualPeriod: formSchema.actualPeriod,
      activity: data.activity,
      activityDetail: data.activityDetail,
      activityDurationExpectedStart: data.activityDurationExpectedStart,
      totalMonth: data.totalMonth || 0,
      activityDurationDate: data.activityDurationDate,
      activityDurationMonth: data.activityDurationMonth,
      underPurpose: [data.underPurpose],
      periodType: data.periodType,
    }

    handleUpdateSave(request)
  }

  const onDelete = (index) => {
    // console.log('onDelete', index)
    let dataList = [...formSchema.value]
    handleDelete(dataList[index])
  }

  const onBackToView = async () => {
    // const _schema = await getActivity(projectId)
    // setFormSchema(_schema)

    const _schema = await getProjectBudget(projectId)
    // _schema?.forms?.managementFee[0]?.subForms.find((item) => {
    //   if (item.activity) {
    //     setFormSchema(item.activity)
    //   }
    // })

    if (_schema?.forms?.activity) {
      setFormSchema(_schema?.forms?.activity)
    }

    onChangeIsEdit(!isEdit)
    setIsError(false)
    setIsDeleteError(false)
    setIsEditDetail(false)
    // onExpanded(true)
    setExpanded(true)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const onEditDetail = (rowData) => {
    console.log('onEditDetail rowData', rowData)
    let schemaObj = formSchema
    // console.log('formSchema => ', formSchema)
    let data = schemaObj.value[rowData.index]
    // console.log('schemaObj', schemaObj)
    // console.log('data', data)
    schemaObj.activityDetail.value = data.activityDetail
    schemaObj.activity.value = data.activity
    schemaObj.activityDurationDate.value = data.activityDurationDate || []
    schemaObj.activityDurationMonth.value = data.activityDurationMonth || []
    schemaObj.activityDurationExpectedStart.value = data.activityDurationExpectedStart
    schemaObj.periodType.value = data.periodType
    schemaObj.totalMonth.value = data.totalMonth
    schemaObj.underPurpose.value = data.underPurpose[0] || data.underPurpose

    // console.log('onEditDetail schemaObj', schemaObj)
    setFormSchema(schemaObj)

    onChangeIsEdit(true)
    setIsEditDetail(true)
    onExpanded(false)
    setExpanded(false)
    setEditDetailIndex(rowData.index)
  }

  const onSetExpanded = (bool, rowData) => {
    let schemaObj = formSchema
    let data = schemaObj.value[rowData.index - 1]

    // schemaObj.activityDetail.value = data.activityDetail
    // schemaObj.activity.value = data.activity
    schemaObj.activityDurationDate.value = data.activityDurationDate || []
    schemaObj.activityDurationMonth.value = data.activityDurationMonth || []
    schemaObj.activityDurationExpectedStart.value = data.activityDurationExpectedStart
    schemaObj.periodType.value = data.periodType
    schemaObj.totalMonth.value = data.totalMonth
    schemaObj.underPurpose.value = data.underPurpose[0] || data.underPurpose

    setFormSchema(schemaObj)

    // onExpanded(bool)
    onChangeIsEdit(true)
    setIsEditDetail(true)
    setEditDetailIndex(rowData.index - 1)
  }

  return (
    <Panel
      shaded={shaded}
      header={formSchema.header}
      collapsible
      defaultExpanded
      bordered
      ref={(section) => {
        setSection(section)
      }}
    >
      <div style={{ marginTop: -10 }}>
        <WarningMessage message={formSchema?.feedbackBySubject} />

        {showMessage && (
          <>
            <Message
              showIcon
              type="error"
              description={
                'ไม่สามารถลบข้อมูลนี้ได้เนื่องจากมีการใช้งานอยู่ กรุณาตรวจสอบ 2.1 ค่าดำเนินโครงการ'
              }
            ></Message>
            <br />
          </>
        )}

        <ActivityBudgetForm
          key="ActivityBudgetForm"
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          setError={setError}
          clearErrors={clearErrors}
          getValues={getValues}
          onSubmit={handleSubmit(onSubmit)}
          onDelete={onDelete}
          showCommandButton={showCommandButton}
          isEditDetail={isEditDetail}
          editDetailIndex={editDetailIndex}
          // onEditActivityBudget={onEditActivityBudgetDetail}

          setExpanded={onSetExpanded}
          // onEditActivityBudget={xxxx}
          // onEdit={onEditDetail}
          isError={isError}
          isDeleteError={isDeleteError}
          loading={isLoading}
          onExpanded={expanded}
          projectVersionId={projectVersionId}
        />
      </div>
    </Panel>
  )
}
